import { v4 as uuidV4 } from 'uuid';
import { TMDXFile } from '@/api/apis/files';

export const mapFilesBeforeUpload = (files: File[]): TMDXFile[] =>
  files.map((f: File) => ({
    file: f,
    id: uuidV4(),
    fileName: f.name,
    path: f.name,
  }));
